export default ({ commit }) => {
  commit("UNSET_LOADING");
};
